import type { SurveyKind } from '../sim/economy';
import { SURVEY_NAMES } from '../sim/operations';

/**
 * The boat's trips as a player names them (M312, the opening loop's G2, the fourth playtest's: "Technical language such
 * as 'reef benthic survey' also remains prominent"). The programs' own names (`SURVEY_NAMES`) stay the record's: the
 * finished trips' titles and the log's events hold them, and are read back by them (`kindOf`), so a save moves nothing;
 * the interface shows these.
 */
export const SURVEY_LABELS: Readonly<Record<SurveyKind, string>> = {
  reefBenthic: 'Coral survey',
  reefFish: 'Grazing fish count',
  reefBleaching: 'Bleaching check',
  slopeCamera: 'Deep 7 camera survey',
  shoreCleanup: 'Shore cleanup',
};

const KINDS = Object.keys(SURVEY_NAMES) as SurveyKind[];

/** A recorded title or a line as a player reads it: each program's name put as its label ("Reef benthic survey finished" → "Coral survey finished"). */
export function plainTitle(text: string): string {
  let out = text;
  for (const k of KINDS) {
    out = out.split(SURVEY_NAMES[k]).join(SURVEY_LABELS[k]).split(SURVEY_NAMES[k].toLowerCase()).join(SURVEY_LABELS[k].toLowerCase());
  }
  return out;
}
